import qs from 'query-string';

export const buildUrl = (pathParams, paramsToQuery) => {
  let urlBuilt = '/schools';

  if (pathParams && pathParams.length)
    pathParams.forEach((path) => {
      if (path && typeof 'path' === 'string') urlBuilt = `${urlBuilt}/${path}`;
    });

  const queryParams = qs.stringify(paramsToQuery);

  if (paramsToQuery) urlBuilt = `${urlBuilt}?${queryParams}`;

  return urlBuilt;
};

export const isGuid = (guid) => {
  const guidPattern = new RegExp(
    '^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
    'i'
  );

  return guidPattern.test(guid);
};

export const getSearchParameters = (query) => ({
  accommodationEndDate: query?.accommodationEndDate || null,
  accommodationId: query?.accommodationId || null,
  accommodationStartDate: query?.accommodationStartDate || null,
  courseId: query?.courseId || null,
  courseStartDate: query?.courseStartDate || null,
  id: query?.id || null,
  startDate: query?.startDate || null,
  weeksQuantity: query?.weekRange || null,
});
